export enum RatesTestIds {
  "SELECT_RATE_BUTTON" = "SELECT_RATE_BUTTON",
  "RATE_ROW" = "RATE_ROW",
  "FETCHED_RATES_PANEL" = "FETCHED_RATES_PANEL",
  "REFETCH_RATES_BUTTON" = "REFETCH_RATES_BUTTON",
  "LOADING_RATES_PANEL" = "LOADING_RATES_PANEL",
  "ERROR_PANEL" = "ERROR_PANEL",
  "NO_RATES_FOUND_PANEL" = "NO_RATES_FOUND_PANEL",
}
